module.exports = function() {
  return new Worker(__webpack_public_path__ + "e7c22b95d13adaa5b23e.worker.js");
};